import React from 'react';
import {injectIntl} from "react-intl";
import {Modal} from "antd";
import SAInputNumber from "../../common/input/SAInputNumber";

import "./SetRentalsMenu.css"

class SetRentalsMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.date) {
      const {data, planning = {}, maxRentalBicycles, maxRentalCars, maxRentalEBikes, maxRentalMotorbikes} = nextProps;

      this.setState({
        maxRentalBicycles: data ? data.maxRentalBicycles : (planning.maxRentalBicycles !== undefined ? planning.maxRentalBicycles : maxRentalBicycles),
        maxRentalCars: data ? data.maxRentalCars : (planning.maxRentalCars !== undefined ? planning.maxRentalCars : maxRentalCars),
        maxRentalEBikes: data ? data.maxRentalEBikes : (planning.maxRentalEBikes !== undefined ? planning.maxRentalEBikes : maxRentalEBikes),
        maxRentalMotorbikes: data ? data.maxRentalMotorbikes : (planning.maxRentalMotorbikes !== undefined ? planning.maxRentalMotorbikes : maxRentalMotorbikes),
        errors: {}
      });
    }
  };

  onInputValidate = () => {
    const errors = this.checkInputForErrors();

    this.setState({errors});

    if (Object.keys(errors).length === 0) {
      this.props.onModalClose();
      this.props.onModalDayChange(this.props.date, this.state.maxRentalBicycles, this.state.maxRentalCars, this.state.maxRentalEBikes, this.state.maxRentalMotorbikes);
    }
  };

  checkInputForErrors = () => {
    const {planning: {currentRentalBicycles = 0, currentRentalCars = 0, currentRentalEBikes = 0, currentRentalMotorbikes = 0} = {}} = this.props;
    const errors = {};

    this.checkInputForErrorsUndefined(errors, this.props.hasBicycle, 'maxRentalBicycles');
    this.checkInputForErrorsUndefined(errors, this.props.hasCar, 'maxRentalCars');
    this.checkInputForErrorsUndefined(errors, this.props.hasEBike, 'maxRentalEBikes');
    this.checkInputForErrorsUndefined(errors, this.props.hasMotorbike, 'maxRentalMotorbikes');

    this.checkInputForErrorsGreaterOrEqual(errors, currentRentalBicycles, 'maxRentalBicycles');
    this.checkInputForErrorsGreaterOrEqual(errors, currentRentalCars, 'maxRentalCars');
    this.checkInputForErrorsGreaterOrEqual(errors, currentRentalEBikes, 'maxRentalEBikes');
    this.checkInputForErrorsGreaterOrEqual(errors, currentRentalMotorbikes, 'maxRentalMotorbikes');

    return errors;
  };

  checkInputForErrorsUndefined(errors, condition, attribute) {
    if (condition && (this.state[attribute] === undefined || this.state[attribute] === null)) {
      errors[attribute] = {message: 'error.not.null'};
    }
  }

  checkInputForErrorsGreaterOrEqual(errors, current, max) {
    if (current > this.state[max] || this.state[max] > this.props[max]) {
      errors[max] = {message: 'error.between', args: [current, this.props[max]]};
    }
  }

  onInputChange = (number, name) => {
    this.setState({[name]: number});
  };

  render() {
    const {intl: {formatMessage}, visible, hasCar, hasMotorbike, hasBicycle, hasEBike} = this.props;

    return (
      <Modal title={formatMessage({id: 'section.rental-planning.modal.title'})} visible={visible} onOk={this.onInputValidate} onCancel={this.props.onModalClose}>
        <div className="set-rentals-menu">
          <ul className="list">
            {hasCar && <li>
              <label>{formatMessage({id: 'rental-planning.maxRentalCars'})}</label>
              <SAInputNumber className={"right"} value={this.state.maxRentalCars} min={0}
                             onChange={(e) => this.onInputChange(e, 'maxRentalCars')}
                             error={this.state && this.state.errors && this.state.errors['maxRentalCars']}
              />
            </li>
            }
            {hasMotorbike &&
              <li>
                <label>{formatMessage({id: 'rental-planning.maxRentalMotorbikes'})}</label>
                <SAInputNumber className={"right"} value={this.state.maxRentalMotorbikes} min={0}
                               onChange={(e) => this.onInputChange(e, 'maxRentalMotorbikes')}
                               error={this.state && this.state.errors && this.state.errors['maxRentalMotorbikes']}
                />
              </li>
            }
            {hasEBike &&
              <li>
                <label>{formatMessage({id: 'rental-planning.maxRentalEBikes'})}</label>
                <SAInputNumber className={"right"} value={this.state.maxRentalEBikes} min={0}
                               onChange={(e) => this.onInputChange(e, 'maxRentalEBikes')}
                               error={this.state && this.state.errors && this.state.errors['maxRentalEBikes']}
                />
              </li>
            }
            {hasBicycle &&
              <li>
                <label>{formatMessage({id: 'rental-planning.maxRentalBicycles'})}</label>
                <SAInputNumber className={"right"} value={this.state.maxRentalBicycles} min={0}
                               onChange={(e) => this.onInputChange(e, 'maxRentalBicycles')}
                               error={this.state && this.state.errors && this.state.errors['maxRentalBicycles']}
                />
              </li>
            }
            <br/>
          </ul>
        </div>
      </Modal>
    )
  }
}

export default injectIntl(SetRentalsMenu);
